// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d6303d63","154":"f27133c5","438":"89621ad8","441":"c8b70530","664":"9451f8b4"}[chunkId] + ".chunk.js";
};